module.exports = __webpack_public_path__ + "883b97a701dcd27077c0b01eedae04ad.svg";